export const supportedContentHashKeys = ['ipfs', 'swarm', 'onion', 'skynet', 'arweave'] as const
